export default __webpack_public_path__ + "static/RobotoMono-regular-535bc89d4af715503b01afd761501e58.woff2";